import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  claimRewardService,
  getRewardsProductsService,
} from "../../services/reward.service";

import { ImageCacheManager } from "store/utils/imageCache";
const imageCacheManager = new ImageCacheManager("productVariations");

export const claimReward = createAsyncThunk(
  "/claimReward",
  async (payload, { rejectWithValue }) => {
    return await claimRewardService(payload, rejectWithValue);
  }
);

export const getRewardsProducts = createAsyncThunk(
  "/getRewardsProducts",
  async (params, { rejectWithValue }) => {
    let response;

    response = await getRewardsProductsService(params, rejectWithValue);

    if (response?.d?.list?.length) {
      const cachedList = await Promise.all(
        response.d.list.map(async (item) => {
          let url = await imageCacheManager.getCachedImageVariationById(
            item.id
          );

          if (!url && item.image) {
            await imageCacheManager.setCachedImageVariationById(
              item.id,
              item.image
            );
            url = item.image;
          }

          return {
            ...item,
            image: url,
          };
        })
      );

      response = {
        ...response,
        d: {
          ...response.d,
          list: cachedList,
        },
      };
    }

    return response;
  }
);
